import { createRoutine } from 'redux-saga-routines';
import * as actionTypes from '../constants/actionTypes';

export const cryptoAddressAnalyses = createRoutine(
  actionTypes.CRYPTO_ADDRESS_ANALYSES,
);
export const cryptoTransactionAnalyses = createRoutine(
  actionTypes.CRYPTO_TRANSACTION_ANALYSES,
);
